<div mat-dialog-content>
    <frog-filter-panel></frog-filter-panel>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="apply()">Apply</button>
    <button mat-button (click)="clear()">Clear All</button>
</div>
